// @flow
import * as React from 'react'

import './RatingDisplay.module.scss'

const RATING_SCALE = 5

type Props = {
  value: number,
  size: number,
  withLabel: boolean,
}

export default class RatingDisplay extends React.Component<Props> {
  static defaultProps = {
    size: 16,
    withLabel: false,
  }

  render = () => {
    const { size, withLabel } = this.props

    return (
      <div styleName="root" style={{ fontSize: size }}>
        <div styleName="stars">
          <div styleName="filled" style={{ width: `${this.fillPercentage * 100}%` }} />
        </div>
        {withLabel && <div styleName="label">{this.labelDisplay}</div>}
      </div>
    )
  }

  get fillPercentage() {
    const { value } = this.props
    if (value < 0) return 0
    if (value >= RATING_SCALE) return 1

    const percentage = value / RATING_SCALE

    // Each 10% increment fills a half star
    return Math.round(percentage / 0.1) * 0.1
  }

  get labelDisplay() {
    const { value } = this.props

    // Trim at 1 decimal without rounding.
    return value.toFixed(2).slice(0, -1)
  }
}
